import httpClient from "./httpClient";

const entityEndpoint = "/options";

export default {
  async managers() {
    const response = await httpClient.get(`${entityEndpoint}/managers`);
    return response.data;
  },

  async mentionables() {
    const response = await httpClient.get(`/mentionables`);
    return response.data;
  },

  async countries() {
    const response = await httpClient.get(`${entityEndpoint}/countries`);
    return response.data;
  },

  async transportModes() {
    const response = await httpClient.get(`${entityEndpoint}/transport_modes`);
    return response.data;
  }
};
